// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"384":"d06bb5a9","706":"9b8b8d6d"}[chunkId] + ".js";
};